const shareEstimateSuccess = (state, action) => {
  const newState = { ...state };
  action.payload.designIds.forEach((id) => {
    const estimate = newState[id];
    estimate.sharedEmail = action.payload.email;
    estimate.sharedDate = action.payload.sharedDate;
  });

  return newState;
};

export default shareEstimateSuccess;
